import React from "react";
import { Form, Radio } from "antd";

const Section8 = ({ formValues, setFormValues }) => {
  return (
    <Form layout="vertical">
      {/* Typical Budget Range */}
      <Form.Item label="30. What is the typical budget range you require to work with a client?">
        <Radio.Group
          value={formValues.budgetRange}
          onChange={(e) =>
            setFormValues({ ...formValues, budgetRange: e.target.value })
          }
        >
          <Radio value="Under $10,000">Under $10,000</Radio>
          <Radio value="$10K-$25K">$10K-$25K</Radio>
          <Radio value="$26K-$35K">$26K-$35K</Radio>
          <Radio value="$36K-$50K">$36K-$50K</Radio>
          <Radio value="$51K-$100K">$51K-$100K</Radio>
          <Radio value="Over $100K">Over $100K</Radio>
        </Radio.Group>
      </Form.Item>

      {/* Clients Below $10K Spend */}
      <Form.Item label="31. Do you work with clients below $10,000 annual ad spend?">
        <Radio.Group
          value={formValues.clientsBelow10k}
          onChange={(e) =>
            setFormValues({ ...formValues, clientsBelow10k: e.target.value })
          }
        >
          <Radio value="Yes">Yes</Radio>
          <Radio value="No">No</Radio>
          <Radio value="Case-by-case">Case-by-case</Radio>
        </Radio.Group>
      </Form.Item>

      {/* References */}
      <Form.Item label="32. If requested, are you able to provide a client reference for the campaigns you listed?">
        <Radio.Group
          value={formValues.clientReferences}
          onChange={(e) =>
            setFormValues({ ...formValues, clientReferences: e.target.value })
          }
        >
          <Radio value="Yes">Yes</Radio>
          <Radio value="No">No</Radio>
          <Radio value="Upon request only">Upon request only</Radio>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};

export default Section8;
